<template>
    <div class="header">
        <div class="left" @click="event_back">
            <i class="iconfont icon-fanhui"></i>
        </div>
        <h2 class="title">{{title}}</h2>
        <slot name="right"></slot>
    </div>
</template>

<script>
    export default {
        name: 'index',
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        methods: {
            event_back() {
                window.history.go(-1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        position: relative;
        height: toRem(88);
        padding: 0 toRem(30);
        font-family: PingFangSC-Medium;
        background-color: #fff;
        .title {
            @extend %flex-horizontal;
            @include box-align(center);
            @include box-pack(center);
            height: 100%;
            font-size: toRem(34);
            font-weight: 700;
        }
        .left, .right {
            position: absolute;
            top: 0;
            height: 100%;
            line-height: toRem(88);
        }
        .left {
            width: toRem(40);
        }
        .icon-fanhui {
            font-size: toRem(45);
        }
        .right {
            top: 1px;
            right: toRem(30);
            font-size: toRem(30);
            font-family: PingFangSC-Medium;
            font-weight: 700;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MHeader/index.vue